module.exports = __webpack_public_path__ + "static/img/102132.d1db756d.png";